<template>
  <div class="task-statistics-page">
    <a-card bordered>
      <div style="display: flex; align-items: center; flex-wrap: wrap; gap: 16px;">
        <!-- 日期范围 -->
        <a-form-item label="日期范围" style="margin-bottom: 0;">
          <a-range-picker
              v-model="dateRange"
              format="YYYY-MM-DD"
              :allowClear="false"
              style="width: 260px"
          />
        </a-form-item>

        <!-- 查询按钮 -->
        <div style="margin-left: auto;">
          <a-button type="primary" @click="handleQuery">
            <a-icon type="search" /> 查询
          </a-button>
          <a-button @click="resetQuery">
            <a-icon type="redo" /> 重置
          </a-button>
        </div>
      </div>

      <!-- 四个统计指标 -->
      <div style="display: flex; justify-content: space-between; margin-top: 24px;">
        <div class="stat-box" @click="openDrawer('facebook')">
          <a-statistic title="Facebook 关注数" :value="stats.facebookCount" />
        </div>
        <div class="stat-box" @click="openDrawer('youtube')">
          <a-statistic title="YouTube 关注数" :value="stats.youtubeCount" />
        </div>
        <div class="stat-box" @click="openDrawer('tiktok')">
          <a-statistic title="Tiktok 关注数" :value="stats.tiktokCount" />
        </div>
        <div class="stat-box" @click="openDrawer('message')">
          <a-statistic title="消息通知已打开" :value="stats.isOpenCount" />
        </div>
        <div class="stat-box" @click="openDrawer('like')">
          <a-statistic title="已设置爱好" :value="stats.isLikeCount" />
        </div>
      </div>
    </a-card>

    <!-- 详情抽屉 -->
    <DetailDrawer
        :visible.sync="drawerVisible"
        :field="activeField"
        :dateRange="dateRange"
    />
  </div>
</template>

<script>
import DetailDrawer from './modules/DetailDrawer.vue'
import moment from 'moment'
import {fetchTaskStatistics} from '@/api/statistics/task-welfare' // 统计接口

export default {
  components: {DetailDrawer},
  data() {
    return {
      dateRange: [moment().startOf('day'), moment().endOf('day')],
      stats: {
        facebookCount: 0,
        youtubeCount: 0,
        tiktokCount: 0,
        isOpenCount: 0,
        isLikeCount: 0
      },
      drawerVisible: false,
      activeField: ''
    }
  },
  mounted() {
    this.fetchStatistics()
  },
  methods: {
    /** 搜索按钮操作 */
    handleQuery () {
      this.fetchStatistics()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        startDate: moment().format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
        pageNum: 1,
        pageSize: 10
      }
      this.dateRange = [moment().startOf('day'), moment().endOf('day')]
      this.handleQuery()
    },
    fetchStatistics() {
      const [start, end] = this.dateRange
      fetchTaskStatistics({
        startDate: start.format('YYYY-MM-DD'),
        endDate: end.format('YYYY-MM-DD')
      }).then(res => {
        this.stats = res.data || {}
      })
    },
    openDrawer(field) {
      this.activeField = field
      this.drawerVisible = true
    }
  }
}
</script>

<style scoped>
.stat-box {
  cursor: pointer;
  flex: 1;
  text-align: center;
  padding: 12px;
  transition: all 0.3s;
  border-radius: 4px;
}

.stat-box:hover {
  background: #f0f5ff;
  box-shadow: 0 0 5px rgba(24, 144, 255, 0.3);
}
</style>
